import { Theme } from '@material-ui/core';

export const styleFormIoComponent = (className: string, theme: Theme) => ({
  [`.${className}`]: {
    '& label.col-form-label, & span.col-form-label': {
      ...theme.typography.textSmallCompact,
      color: `${theme.colors.textMainSecondary} !important`,
      height: 'auto',
      padding: 0,
      marginBottom: theme.spacing(1),
      display: 'inline-block',
    },
    '& .form-text.text-muted': {
      display: 'none',
    },
    '&.formio-error-wrapper': {
      backgroundColor: theme.colors.layoutBackgroundPrimary,
      padding: 0,
    },
    '& .formio-errors.invalid-feedback': {
      display: 'none',
    },
    '& .field-required:after': {
      color: theme.colors.textErrors,
      ...theme.typography.textTiny,
    },
  },
  [`.formio-dialog ${className} p`]: {
    marginBottom: 0,
  },
});
